import { create } from "zustand";
import type { WbStoreItem, StoreStats } from "./wb-stores-types";
import * as api from "./wb-stores-api";

interface WbStoresState {
  stores: WbStoreItem[];
  total: number;
  stats: StoreStats | null;
  query: string;
  syncStatus: string; // "" (все) или "error"
  page: number;
  limit: number;
  loading: boolean;
  fetchStores: () => Promise<void>;
  setQuery: (q: string) => void;
  setSyncStatus: (s: string) => void;
  setPage: (p: number) => void;
  setLimit: (l: number) => void;
}

let debounceTimer: ReturnType<typeof setTimeout>;

export const useWbStoresStore = create<WbStoresState>((set, get) => ({
  stores: [],
  total: 0,
  stats: null,
  query: "",
  syncStatus: "",
  page: 1,
  limit: 25,
  loading: false,

  fetchStores: async () => {
    const { query, syncStatus, page, limit } = get();
    set({ loading: true });
    try {
      const res = await api.getWbStores({
        query: query || undefined,
        sync_status: syncStatus || undefined,
        page,
        limit,
      });
      set({
        stores: res.stores ?? [],
        total: res.total,
        stats: res.stats ?? null,
        loading: false,
      });
    } catch {
      set({ loading: false });
    }
  },

  setQuery: (query) => {
    set({ query, page: 1 });
    clearTimeout(debounceTimer);
    debounceTimer = setTimeout(() => get().fetchStores(), 300);
  },

  setSyncStatus: (syncStatus) => {
    set({ syncStatus, page: 1 });
    get().fetchStores();
  },

  setPage: (page) => {
    set({ page });
    get().fetchStores();
  },

  setLimit: (limit) => {
    set({ limit, page: 1 });
    get().fetchStores();
  },
}));
